import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import Tabbar from '@components/Tabbar';
import {
  $viewMode,
  $viewModeApi,
  $viewModeDisplay,
} from '@stores/viewModeStores';

function ViewModeSwitch() {
  const mode = useStore($viewMode);
  const display = useStore($viewModeDisplay);
  const activeIndex = mode === 'mobile' ? 1 : 0;
  useEffect(() => $viewModeApi.pc, []);
  if (!display) return null;
  return (
    <div className="absolute top-15 left-15 w-250">
      <Tabbar
        tabs={['桌面端', '移动端']}
        activeIndex={activeIndex}
        onChange={(index) => {
          if (index === 1) {
            $viewModeApi.mobile();
          } else {
            $viewModeApi.pc();
          }
        }}
      />
    </div>
  );
}

export default ViewModeSwitch;
